<div class="flex flex-col gap-3">
	@if (isFeatured()) {
		@if (uniId() && isFeatured()) {
			<uc-visit-website-btn
				customStyles="w-full"
				[externalUrl]="externalUrl()"
				[product]="product()"
				[componentName]="componentName()"
				[uniId]="uniId()"
				buttonText="Visit Website"
				[source]="uniName()"
				sourceType="uni"
				[ugSearchOrderPosition]="ugSearchOrderPosition()"
				[uniName]="uniName()"
			/>
		}
		<uc-request-btn
			[params]="uniId()"
			[componentName]="componentName()"
			customStyles="w-full sm:w-full"
			[product]="product()"
			[courseName]="courseName()"
			[ugSearchOrderPosition]="ugSearchOrderPosition()"
		/>
		<uc-book-event-btn
			customStyles="w-full"
			[componentName]="componentName()"
			[externalUrl]="externalEventsUrl()"
			[uniId]="uniId()"
			[product]="product() ?? productEnum.Undergraduate"
			[ugSearchOrderPosition]="ugSearchOrderPosition()"
			[privacyPolicyUrl]="privacyPolicyUrl()"
			[uniName]="uniName()"
		/>
		<uc-prospectus-btn
			customStyles="w-full mb-0"
			[params]="uniId()"
			[link]="externalProspectusUrl()"
			[componentName]="componentName()"
			[product]="product()"
			[privacyPolicyUrl]="privacyPolicyUrl()"
			[showModal]="true"
			[isFeaturedPostgraduate]="isFeaturedPostgraduate()"
			[isFeaturedUndergraduate]="isFeaturedUndergraduate()"
			[ugSearchOrderPosition]="ugSearchOrderPosition()"
		/>
	} @else {
		<uc-write-review-btn
			[universityId]="uniId()"
			[universityUrl]="uniSlug()"
			[universityName]="uniName()"
			customStyles="block w-full secondary-button only-tab-focus !no-underline"
		/>
		@if (!showRecommendedButton()) {
			<uc-primary-blue-btn
				[link]="universitiesLink()"
				customStyles="w-full"
				buttonText="View Recommended Universities"
			/>
		}
	}
</div>
